export const StatusLoteMap = {
  ['CRIADO']: { label: 'Processando', color: '#EEB03D' },
  ['EM_VALIDACAO']: { label: 'Processando', color: '#EEB03D' },
  ['ABERTO']: { label: 'Processando', color: '#EEB03D' },
  ['AGENDADO']: { label: 'Processando', color: '#EEB03D' },
  ['EM_EXECUCAO']: { label: 'Processando', color: '#EEB03D' },
  ['FINALIZADO']: { label: 'Finalizado', color: '#5B5B5B' },
  ['CANCELADO']: { label: 'Finalizado', color: '#5B5B5B' },
  ['ERRO']: { label: 'Erro', color: '#DC3545' },
  ['EM_PROCESSAMENTO']: { label: 'Processando', color: '#EEB03D' },
};
